import { safeDayjs } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { DebtPaymentPlan } from "./debtPaymentPlan"
import { DebtPaymentPlanStatus } from "./debtPaymentPlan.types"
import { PaymentPlan } from "@/api/backofficeRest/generated/model"

export type DebtPaymentPlanRaw = PaymentPlan

export const DebtPaymentPlanParser: IParser<
  DebtPaymentPlan,
  DebtPaymentPlanRaw
> = {
  toDomain: (data: DebtPaymentPlanRaw) => {
    try {
      return new DebtPaymentPlan(
        data.status as DebtPaymentPlanStatus,
        Number(data.id),
        data.planLengthInMonths,
        data.remainingPaymentMonths ?? 0,
        dayjs(data.createdAt),
        data.totalDebt ? Number(data.totalDebt) : undefined,
        data.debtMonthlyPayment ? Number(data.debtMonthlyPayment) : undefined,
        data.remainingBalance ? Number(data.remainingBalance) : undefined,
        data.paymentDay ?? undefined,
        safeDayjs(data.lastPaymentDate),
        data.type ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
